import React, { useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  // Col,
  // Label,
  // Row,
} from "reactstrap";
import { Link } from "react-router-dom";
// import { APP_LOGO } from "../../config/index";
import AuthFooter from "../../components/Footers/AuthFooter";
import { APP_LOGO } from "../../config";
import { Carousel } from "react-bootstrap";
import Plyr from "plyr-react";
import "plyr-react/plyr.css";
import { getSettingsData } from "../../http/http-calls";
import { showToast } from "../../helper-methods";
// import CustomVideo from "../../components/CustomVideo";

const LoginPage = () => {
  const [imageData, setImageData] = React.useState([]);

  const _fetchImageData = async () => {
    try {
      const res = await getSettingsData();
      setImageData(res?.setting?.picture);
    } catch (error) {
      showToast(error?.reason, "error");
    }
  };

  useEffect(() => {
    _fetchImageData();
  }, []);
  return (
    <div className="vayco-public login_singup">
      <div className="app animated fadeIn ">
        <div className="public-header flex-md-row flex-column">
          <Link to="/" className="public-logo">
            <img src={APP_LOGO} alt="Logo" loading="lazy" />
            {/* <span>Navigate Hamilton County</span> */}
          </Link>

          {/* <a
            rel="noreferrer"
            className="d-flex flex-column align-items-center text-dark"
            target="_blank"
            href="https://submit.jotform.com/241194085951157"
          >
            <i className="fas fa-headset fs-30 w-auto"></i>
            <span className="fs-14 mt-1">Need Help?</span>
          </a> */}
          <h5 className="headerTitle">Find Help. Get Help. Give Help</h5>
        </div>
        {/* <div className="login_wrapper d-flex align-items-center justify-content-center px-3">
          <div className="d-flex flex-column text-center">
            <Link to="/service-selection" className="btn btn-primary">
              Get Resources
            </Link>
            <Link to="/navigatorconnect" className="btn btn-primary mt-4">
              Connect to a Navigator
            </Link>
            <Link to="/resources" className="btn btn-primary mt-4">
              Become a Provider
            </Link>
            <Label className="mt-3">Select which option is best for you</Label>
            <p className="create-account mt-4 mb-0">
              Already a resident?
              <Link to="/login" className="ml-1">
                Login
              </Link>
            </p>
          </div>
        </div> */}
        <div className="login_wrapper">
          <div className="welcome-sponsored-video-container">
            <Card>
              <CardHeader>
                <CardTitle>Welcome Video</CardTitle>
              </CardHeader>
              <CardBody>
                <div className="">
                  <Plyr
                    source={{
                      type: "video",
                      sources: [
                        {
                          // src: "https://stronger-vet.s3.us-east-2.amazonaws.com/Anyone+Can+Get+Broken+-+Ep.+1+_++Moving+America's+Soul+on+Suicide.mp4",
                          src: "https://navigatehc.s3.us-east-2.amazonaws.com/WEBVIDEO.mp4",
                          type: "video/mp4",
                        },
                      ],
                    }}
                    options={{
                      controls: [
                        "play",
                        "progress",
                        "current-time",
                        "mute",
                        "volume",
                        "settings",
                        "fullscreen",
                      ],
                    }}
                  />
                  {/* <CustomVideo /> */}
                </div>
              </CardBody>
            </Card>
            <Card>
              <CardHeader>
                <CardTitle>Select which option is best for you</CardTitle>
              </CardHeader>
              <CardBody className="text-center">
                <Link to="/service-selection" className="btn btn-primary">
                  Get Resources
                </Link>
                <Link to="/navigatorconnect" className="btn btn-primary">
                  Connect to a Navigator
                </Link>
                <Link to="/resources" className="btn btn-primary">
                  Join Resource Database
                </Link>

                <p className="create-account mt-4 mb-0">
                  Have an account?
                  <Link to="/login" className="ml-1">
                    Login
                  </Link>
                </p>
              </CardBody>
            </Card>
            <Card>
              <CardHeader>
                <CardTitle>Sponsored</CardTitle>
              </CardHeader>
              <CardBody>
                <Carousel>
                  {imageData?.map((data, index) => (
                    <Carousel.Item>
                      <img src={data?.url} key={index} alt="Ad 1" />
                    </Carousel.Item>
                  ))}
                </Carousel>
              </CardBody>
            </Card>
          </div>

          <p className="fs-16 text-muted text-center mt-4">
            Welcome to Navigate Hamilton County—your local hub for behavioral
            health and wellness support. Whether you’re looking for mental
            health care, food, housing assistance, or other vital services, our
            easy-to-use platform helps you find the right resources nearby,
            filtered by your zip code. Need personal guidance? Our live
            Navigators are ready to walk you through the system and connect you
            to the help you need, fast. If you're a service provider, you can
            join our directory and reach the people who need you most. At
            Navigate Hamilton County, finding help, getting help, and giving
            help has never been simpler.
          </p>
        </div>

        <AuthFooter />
      </div>
    </div>
  );
};

export default LoginPage;
